module.exports = __webpack_public_path__ + "static/media/wheatgrass.612a1dc8.png";